import React from 'react';
import { useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import { Button } from 'react-bootstrap';
import "assets/stylesheets/App.css";

function AlertDismissibleExample() {
  const [show, setShow] = useState(true);

  if (show) {
  return (
    <Alert variant="info" className='dimissibleAlert'>
    <Button onClick={() => setShow(false)} aria-label="Close" >
      X
    </Button>
    <Alert.Heading className='settingAlertDiv'>RIGHT-CLICK FOR MORE CUSTOM SETTINGS</Alert.Heading>
    </Alert>
  );
  }
  return null;
}

export default AlertDismissibleExample;